import { createRoot } from 'react-dom/client';

import { ClerkProvider } from '@clerk/clerk-react';

import { getEnvironmentConfig } from '@/lib/environment';

import { App } from './App.tsx';
import './index.css';

const config = getEnvironmentConfig();

const PUBLISHABLE_KEY = config.clerkPublishableKey;

if (!PUBLISHABLE_KEY) {
  throw new Error('Missing Clerk Publishable Key');
}

const rootElement = document.getElementById('root');

if (rootElement) {
  createRoot(rootElement).render(
    <ClerkProvider publishableKey={PUBLISHABLE_KEY} touchSession={false}>
      <App />
    </ClerkProvider>
  );
}
